export default __webpack_public_path__ + "static/media/privilege-discount-yellow.817fff1f.svg";